/**
 * Query key factory for voting-related queries
 * Follows the same pattern as booksQueryKeys
 */
export const votingQueryKeys = {
    /** All voting queries */
    all: ["voting"] as const,

    /** Single voting period by ID */
    period: (id: string) => [...votingQueryKeys.periods(), id] as const,

    /** All voting periods */
    periods: () => [...votingQueryKeys.all, "periods"] as const,
};
